// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"c66f40b2","473":"53716a8d","487":"dce1e900","614":"ebec54e6","745":"be285712","781":"3d9acc22","787":"e88f3a2c"}[chunkId] + ".chunk.js";
};